export enum FORM_MASK_ENUM {
  PHONE_NUMBER = '(000) 000-0000',
}
